/*
 * @Author: Tina Huang
 * @Date: 2024-03-05 12:13:46
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 16:22:39
 * @Description:
 */
import BindVIP from '@/components/modals/BindVIP'
import { createElement, useCallback, useRef } from 'react'
import ReactDOM from 'react-dom'
export default function useBind(): {
  show: () => void
  close: () => void
} {
  const domRef = useRef(null)
  // const [open, setOpen] = useState(false)
  const close = useCallback(() => {
    const dom: any = domRef.current

    ReactDOM.unmountComponentAtNode(dom)

    if (dom && dom.parentNode) {
      dom.parentNode.removeChild(dom)
    }
  }, [])
  const show = useCallback(() => {
    const Root = document.body

    if (!domRef.current) {
      // 创建一个dom
      domRef.current = document.createElement('div') as any
      Root.appendChild(domRef?.current as any)
    }

    const dom = domRef.current as any
    const ele = createElement(BindVIP, { open: true, onClose: close }) as any
    ReactDOM.render(ele, dom)
  }, [close])

  return { show, close }
}
